import React from "react"
import NumberFormat from "../../../utils/numberFormat"
import { capitalize } from "lodash"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"

const EstimateRenderTable = ({
  tasks,
  projectProfit,
  prefix = "",
  longrevision,
}) => {
  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const getExcelColumnLabel = index => {
    let label = ""
    while (index >= 0) {
      label = String.fromCharCode((index % 26) + 65) + label
      index = Math.floor(index / 26) - 1
    }
    return label
  }

  const columnCount = longrevision ? 11 : 5

  if (longrevision) {
    console.log("tasks", tasks)
    return (
      <>
        {tasks?.map((itm, i) => {
          const currentNumber = prefix ? `${prefix}.${i + 1}` : `${i + 1}`
          const unitPrice =
            Number(itm?.consumables) +
            Number(itm?.fittings) +
            Number(itm?.manpower) +
            Number(itm?.material) +
            Number(itm?.overhead_profit) +
            Number(itm?.sub_contract)
          return (
            <React.Fragment key={currentNumber}>
              <tr className="fs-13 fw-500">
                <td className="wdt-33 ps-2">
                  {currentNumber} {capitalize(itm?.name)}
                </td>
                <td className="text-end">
                  {Number(itm?.qty).toFixed(desimalrange)}
                </td>
                <td className="ps-3">{itm?.unit?.unit_code}</td>
                <td className="text-end">
                  {NumberFormat(unitPrice, desimalrange, desimalrange) || 0}
                </td>
                {/* <td className="pe-4 text-end">
                {NumberFormat(Number(unitPrice || 0) * Number(itm?.qty), desimalrange, desimalrange)}
              </td> */}
                <td className="text-end">{NumberFormat(Number(itm?.material), desimalrange, desimalrange)}</td>
                <td className="text-end">{NumberFormat(Number(itm?.fittings), desimalrange, desimalrange)}</td>
                <td className="text-end">{NumberFormat(Number(itm?.consumables), desimalrange, desimalrange)}</td>
                <td className="text-end">{NumberFormat(Number(itm?.manpower), desimalrange, desimalrange)}</td>
                <td className="text-end">{NumberFormat(Number(itm?.sub_contract), desimalrange, desimalrange)}</td>
                <td className="text-end pe-1">
                  {NumberFormat(Number(itm?.overhead_profit), desimalrange, desimalrange)}
                </td>
                <td className="pe-4 text-end">
                  {NumberFormat(
                    Number(unitPrice || 0) * Number(itm?.qty),
                    desimalrange,
                    desimalrange
                  )}
                </td>
              </tr>
              {itm?.description ? (
                <tr>
                  <td className="ps-3 fs-13">{itm?.description}</td>
                </tr>
              ) : (
                <></>
              )}
              {i != tasks?.length - 1 ? (
                <tr className="w-100">
                  {[...Array(columnCount)].map((_, idx) => (
                    <td className="render-tbl-border-btm" key={idx}></td>
                  ))}
                </tr>
              ) : (
                ""
              )}
              {itm?.tasks?.length > 0 && (
                <EstimateRenderTable
                  tasks={itm?.tasks}
                  projectProfit={projectProfit}
                  prefix={currentNumber}
                  longrevision={longrevision}
                />
              )}
            </React.Fragment>
          )
        })}
      </>
    )
  }

  return (
    <>
      {tasks?.map((itm, i) => {
        const currentNumber = prefix ? `${prefix}.${i + 1}` : `${i + 1}`
        const unitPrice =
          Number(itm?.consumables) +
          Number(itm?.fittings) +
          Number(itm?.manpower) +
          Number(itm?.material) +
          Number(itm?.overhead_profit) +
          Number(itm?.sub_contract)
        return (
          <React.Fragment key={currentNumber}>
            <tr className="fs-13 fw-500">
              <td className="wdt-33 ps-2">
                {currentNumber} {capitalize(itm?.name)}
              </td>
              <td className="text-end">
                {Number(itm?.qty).toFixed(desimalrange)}
              </td>
              <td className="ps-3">{itm?.unit?.unit_code}</td>
              <td className="text-end">
                {NumberFormat(unitPrice, desimalrange, desimalrange) || 0}
              </td>
              <td className="pe text-end">
                {NumberFormat(
                  Number(unitPrice || 0) * Number(itm?.qty),
                  desimalrange,
                  desimalrange
                )}
              </td>
            </tr>
            {itm?.description ? (
              <tr>
                <td className="ps-3 fs-13">{itm?.description}</td>
              </tr>
            ) : (
              <></>
            )}
            {/* {itm?.estimation_material?.length > 0 && (
              <>
                <tr>
                  <td className="ps-3 fs-13 fw-500">Estimation Material</td>
                </tr>
                {itm?.estimation_material?.map((dt, i) => (
                  <tr key={`material-${currentNumber}-${i}`} className="fs-13">
                    <td className="ps-3">
                      ({getExcelColumnLabel(i)}){" "}
                      {capitalize(dt?.products?.description)}
                    </td>
                    <td className="ps-3">{dt?.unit?.unit_code}</td>
                    <td className="text-end">
                      {NumberFormat(Number(dt?.quantity))}
                    </td>
                    <td className="text-end">
                      {NumberFormat(
                        Number(
                          Number(dt?.price) +
                            (Number(dt?.price) * Number(projectProfit)) / 100
                        ),
                        3
                      )}
                    </td>
                    <td className="pe text-end">
                      {NumberFormat(
                        Number(dt?.quantity) *
                          (Number(dt?.price) +
                            (Number(dt?.price) * Number(projectProfit)) / 100),
                        3
                      )}
                    </td>
                  </tr>
                ))}
              </>
            )}
            {itm?.estimation_manpower?.length > 0 && (
              <>
                <tr>
                  <td className="ps-3 fs-13 fw-500">Estimation Manpower</td>
                </tr>
                {itm?.estimation_manpower.map((dt, i) => (
                  <tr key={`material-${currentNumber}-${i}`} className="fs-13">
                    <td className="ps-3">
                      ({getExcelColumnLabel(i)}) {dt?.category_id?.description}
                    </td>
                    <td className="ps-3">Hrs</td>
                    <td className="text-end">
                      {NumberFormat(Number(dt?.no_of_labours || 1))}
                    </td>
                    <td className="text-end">
                      {NumberFormat(
                        Number(
                          Number(dt?.price) +
                            (Number(dt?.price) * Number(projectProfit)) / 100
                        ),
                        3
                      )}
                    </td>
                    <td className="pe text-end">
                      {NumberFormat(
                        Number(dt?.no_of_labours) *
                          (Number(dt?.price) +
                            (Number(dt?.price) * Number(projectProfit)) / 100),
                        3
                      )}
                    </td>
                  </tr>
                ))}
              </>
            )}
            {itm?.estimation_subcontract?.length > 0 && (
              <>
                <tr>
                  <td className="ps-3 fs-13 fw-500">Estimation Subcontract</td>
                </tr>
                {itm?.estimation_subcontract?.map((dt, i) => (
                  <tr
                    key={`subcontract-${currentNumber}-${i}`}
                    className="fs-13"
                  >
                    <td className="ps-3">
                      ({getExcelColumnLabel(i)}) {dt?.category_id?.description}
                    </td>
                    <td className="ps-3">{dt?.unit?.unit_code}</td>
                    <td className="text-end">
                      {NumberFormat(Number(dt?.duration || 1))}
                    </td>
                    <td className="text-end">
                      {NumberFormat(
                        Number(
                          Number(dt?.price) +
                            (Number(dt?.price) * Number(projectProfit)) / 100
                        ),
                        3
                      )}
                    </td>
                    <td className="pe text-end">
                      {NumberFormat(
                        Number(dt?.duration || 1) *
                          (Number(dt?.price) +
                            (Number(dt?.price) * Number(projectProfit)) / 100),
                        3
                      )}
                    </td>
                  </tr>
                ))}
              </>
            )} */}
            {i != tasks?.length - 1 ? (
              <tr className="w-100">
                <td className="render-tbl-border-btm"></td>
                <td className="render-tbl-border-btm"></td>
                <td className="render-tbl-border-btm"></td>
                <td className="render-tbl-border-btm"></td>
                <td className="render-tbl-border-btm"></td>
              </tr>
            ) : (
              ""
            )}
            {itm?.tasks?.length > 0 && (
              <EstimateRenderTable
                tasks={itm?.tasks}
                projectProfit={projectProfit}
                prefix={currentNumber}
                longrevision={longrevision}
              />
            )}
          </React.Fragment>
        )
      })}
    </>
  )
}

export default EstimateRenderTable
